import { IServices } from 'services/services';
import { LayoutHOC } from 'base/ui/layout/layout';
import { createHomePage } from './dashboard/create';
import { createLoginPage } from './login/create';
import { createModulePage } from './module/create';
import { createCustomerInfoPage } from './customerInfo/create';
import { createIconPage } from './iconScreen/create';
import { createFormSurveyPage } from './khaosat/create';
import { createAddSurveyPage } from './khaosat/addSurvey/create';


import { createReminderPage } from './Reminder/create';

import { createZNSPage } from './ZNS/create'
import { createCustomerPage } from './Customer/create';
import { createProjectManagementPage } from './projectManagement/create';
import { createEventCampaignPage } from './eventCampaign/create';
import { createMarketingCampaignPage } from './marketingCampaign/create';
import { createComplaintPage } from './warranty&Complaint/create';
import { createCampaignPage } from './Campaign/create';
import { createSurveyReportPage } from './khaosat/SurveyReport/create';
import { createFeedbackPage } from './khaosat/feedback/create';
import { createReportVisitCustomerPage } from './reportVisitCustomer/create';
import { createUtilitiesPage } from './extensions/create';
import { createMasterDataPage } from './masterdata/create';
import { createExchangeRewardsPage } from './ExchangeRewards/create';


export function createPages(layoutHOC: LayoutHOC, services: IServices) {
  return {
    HomePage: createHomePage(layoutHOC),
    LoginPage: createLoginPage(layoutHOC),
    // trang modules
    ModulePage: createModulePage(layoutHOC),
    // Thông tin khách hàng
    CustomerInfoPage: createCustomerInfoPage(layoutHOC),
    // Xem icons
    IconsPage: createIconPage(layoutHOC),

    // Khát sát
    FormSurveyPage: createFormSurveyPage(layoutHOC),
    AddSurveyPage: createAddSurveyPage(layoutHOC),
    EditSurveyPage: createAddSurveyPage(layoutHOC),
    SurveyReportPage: createSurveyReportPage(layoutHOC),
    // Trang phản hồi
    FeedbackPage: createFeedbackPage(layoutHOC),

    // ============================== ZNS ================================
    ZNSPage: createZNSPage(layoutHOC),

    // ============================== REMINDERS ================================
    RemindPage: createReminderPage(layoutHOC),
    // ============================== CUSTOMERS ================================
    CustomerPage: createCustomerPage(layoutHOC),
    // ============================== PROJECT MANAGEMENT ================================
    ProjectManagementPage: createProjectManagementPage(layoutHOC),
    // ============================== EVENT CAMPAIGN ================================
    EventCampaignPage: createEventCampaignPage(layoutHOC),
    // =============================BÁO CÁO BẢO HÀNH - KHIẾU NẠI=====================
    WarrantyAndComplaintPage: createComplaintPage(layoutHOC),
    // ============================== CHIẾN DỊCH MARKETING ================================
    MarketingCampaignPage: createMarketingCampaignPage(layoutHOC),
    // ============================== CAMPAIGN ================================
    CampaignPage: createCampaignPage(layoutHOC),
    // ============================= Báo cáo thăm hỏi khách hàng ghé thăm =================================
    ReportVisitCustomerPage: createReportVisitCustomerPage(layoutHOC),
    // ====================================== Tiện ích ====================================================
    PageUtilities: createUtilitiesPage(layoutHOC),
    // ====================================== Bảo hành khiếu nại ====================================================

    // ============================= Dữ liệu nền ================================================================
    MasterdataPage: createMasterDataPage(layoutHOC),



    // =========================== Tích điểm đổi quà =================================
    ExchangeRewardsPage: createExchangeRewardsPage(layoutHOC)
  };
}
